// @flow
import rootReducer from '../../REDUCERS/rootReducer'
import initialState from "../../REDUCERS/initialState";
import commonInitialState from "../REDUCERS/commonInitialState";
import {createContext, useReducer} from "react";

const combinedState = {...initialState,...commonInitialState};

const StoreProvider = ({children}) => {
    const [state, dispatch] = useReducer(rootReducer, combinedState);  
    return (
        <StoreContext.Provider value={[state, dispatch]} displayName="StoreProvider">{children}</StoreContext.Provider>
    );
}

export const StoreContext = createContext(combinedState);
export default StoreProvider;